export const WIDGET_LIST = 'widgets';
export const PAGES = 'pages';

export const WIDGET_STATUS_MATCH = 'MATCH';
export const WIDGET_STATUS_DIFF = 'DIFF';
export const WIDGET_STATUS_REMOVED = 'REMOVED';
